import { useQuery } from '@tanstack/react-query';
import { useIsConfigConstantEqual } from 'hooks/useConfigConstant';
import { conciergeAPI } from 'api/concierge';
import { IDomain } from 'store/conciergeSlice';

export function useHasConciergeDomains(): { hasDomains: boolean; isLoading: boolean } {
    const isEnabledConciergeIcon = useIsConfigConstantEqual('ENABLE_CONCIERGE_ICON', true);
    const isEnabledConcierge = useIsConfigConstantEqual('ENABLE_CONCIERGE', true);

    const { data, isLoading } = useQuery<IDomain[]>({
        queryKey: ['conciergeDomains'],
        queryFn: () => conciergeAPI.getDomains(),
        enabled: isEnabledConcierge && isEnabledConciergeIcon,
        staleTime: 5 * 60 * 1000,
    });

    return {
        hasDomains: isLoading ? true : (data?.length ?? 0) > 0,
        isLoading,
    };
}
